import select from 'dom-select';

const detectExternalLink = (el) => {
  const currentDomain = window.location.hostname;
  const currentHref = el.getAttribute('href');
  const currentTarget = el.getAttribute('target');

  const ui = {
    confirmation: select('.external-link'),
    confirmationLink: select('.external-link__location'),
  }

  if (currentHref !== null && currentHref !=='') {
    if (!currentHref.includes(currentDomain) && currentHref.includes('//')) {
      el.classList.add('external');

      el.addEventListener('click', () => {
        el.removeAttribute('href'); // maybe not needed
        ui.confirmationLink.setAttribute("href", currentHref);
        // If target attribute is set, respect + apply this to modal link
        if (currentTarget !== null && currentTarget !=='') {
          ui.confirmationLink.setAttribute("target", currentTarget);
        }
        else{
          // always reset this attribute to html5 default in case previous link click set '_blank' value
          ui.confirmationLink.setAttribute("target", "_self");
        }
        ui.confirmationLink.setAttribute("rel", "noopener");
        ui.confirmation.classList.add('external-link--is-active');
      })
    }
  }
};

export default detectExternalLink;
